export default "__VITE_ASSET__BtkGyojM__"